<div
  *ngIf="!imageSrc; else deletephoto"
  class="upload-btn"
  [ngClass]="{
    hidden: imageSrc,
    disable: disabled
  }"
  (click)="browse()"
>
  <i-feather name="upload" class="icon"></i-feather>
  <div class="add-contact-link">Upload</div>
</div>
<ng-template #deletephoto>
  <div
    *ngIf="isImageSelected || imageSrc"
    class="delete-photo"
    (click)="onImageRemove()"
  >
    <i-feather name="trash-2" class="icon"></i-feather>
    <span>Delete</span>
  </div>
</ng-template>
<div id="image-uploader" class="e-card-content">
  <div class="photo-container" *ngIf="imageSrc">
    <img class="photo big" [src]="imageSrc" />
    <img class="photo medium" [src]="imageSrc" />
    <img class="photo small" [src]="imageSrc" />
  </div>
  <div
    [class.hidden]="imageSrc"
    id="droparea"
    class="droparea"
    [ngClass]="{ disabled: disabled }"
    (click)="browse()"
  >
    <mat-icon class="upload-icon m-2">cloud_upload</mat-icon>
    <div class="text-dropzone-primary pt-3">Drag and Drop files to upload</div>
    <div class="text-dropzone-secondary pt-2">or browse files</div>
    <div class="text-dropzone-tertiary pt-1">.jpg or .png maximum 5MB</div>
  </div>
  <ejs-uploader
    #previewupload
    [dropArea]="dropElement"
    [allowedExtensions]="allowedExtensions"
    [autoUpload]="false"
    [multiple]="false"
    [enabled]="!disabled"
    [maxFileSize]="maxFileSize"
    (selected)="onImageSelect($event)"
    (removing)="onImageRemove()"
  >
  </ejs-uploader>
</div>
